import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import SignupConfirm from './pages/SignupConfirm';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Post from './pages/Post';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Leads from './pages/Leads';
import Ops from './pages/Ops';

const API_URL = process.env.REACT_APP_API_URL || '';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!localStorage.getItem('access_token'));
  const [user, setUser] = useState(null);

  const handleLogin = (token, userData) => {
    localStorage.setItem('access_token', token);
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    setIsAuthenticated(false);
    setUser(null);
  };

  // Recupera o perfil de uma sessão salva; token inválido/expirado volta ao login.
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) return;
    axios
      .get(`${API_URL}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setUser(data))
      .catch(() => handleLogout());
  }, []);

  const privateRoute = (element) => (isAuthenticated ? element : <Navigate to="/login" />);

  return (
    <BrowserRouter basename="/">
      <div className="app">
        <Routes>
          <Route path="/login" element={!isAuthenticated ? <Login onLogin={handleLogin} /> : <Navigate to="/dashboard" />} />
          <Route path="/signup/confirm" element={<SignupConfirm onLogin={handleLogin} />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={privateRoute(<Dashboard user={user} onLogout={handleLogout} />)} />
          <Route path="/news" element={privateRoute(<News user={user} onLogout={handleLogout} />)} />
          <Route path="/news/:id" element={privateRoute(<NewsDetail user={user} onLogout={handleLogout} />)} />
          <Route path="/leads" element={privateRoute(<Leads user={user} onLogout={handleLogout} />)} />
          <Route path="/ops" element={privateRoute(<Ops user={user} onLogout={handleLogout} />)} />
          <Route path="/posts/:id" element={privateRoute(<Post user={user} onLogout={handleLogout} />)} />
          <Route path="*" element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
